import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Benutzer extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;
    aktiv: boolean | null = null;
    username: string | null = null;
    rolle_id: number | null = null;
    nachname: string | null = null;
    vorname: string | null = null;
    email: string | null = null;
    // wird nicht ausgeliefert: wird zum Aendern im Backend verwendet.
    passwort: string | null = null;
    passwort_aendern_verlangt: boolean | null = null;
    letzter_login: Dayjs | null = null;
    anzahl_logins: number | null = null;
    login_versuche: number | null = null;
    bemerkung: string | null = null;

    // view fields:
    rolle: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
            letzter_login: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Benutzer';
    }

    get name() {
        const name = [];
        if (this.vorname) {
            name.push(this.vorname);
        }
        if (this.nachname) {
            name.push(this.nachname);
        }
        if (name.length === 0) {
            return this.username;
        }
        return name.join(' ');
    }

    get initialen() {
        const initialen = [];
        if (this.vorname) {
            initialen.push(this.vorname[0].toUpperCase());
        }
        if (this.nachname) {
            initialen.push(this.nachname[0].toUpperCase());
        }
        if (initialen.length === 0) {
            return this.username ? this.username[0].toUpperCase() : '';
        }
        return initialen.join('');
    }
}

export async function createNewUser(): Promise<Benutzer> {
    const user = createModel(Benutzer, {});

    await user.save();
    return user;
}

export class BenutzerCollection extends BaseCollection<Benutzer> {
    protected modelCls = Benutzer;

    public getModelClassName(): string {
        return 'Benutzer';
    }
}
